import { Box, Button, Flex, Text, useToast } from "@chakra-ui/react";
import { FaUser } from "react-icons/fa";
import { MdContentCopy, MdWhatsapp } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import FollowupLogNotificationService from "../../services/FollowupLogs";

export const ChatTemplate = ({
  name,
  phoneNumber,
  followupLogData,
  setFollowupLogData,
  isWhatsappUnavailable,
}: any) => {
  const loggedInUser = localStorage.getItem("logged_in_user_id");
  const toast = useToast();

  const { email, original_status, current_status } = followupLogData;

  const copyToClipboard = async () => {
    const textToCopy = `${phoneNumber}`;
    try {
      await navigator?.clipboard?.writeText(textToCopy);
      await FollowupLogNotificationService.createFollowupLog({
        email,
        assigned_expert: loggedInUser,
        channel: "call/text",
        template: "",
        original_status,
        current_status,
      });
      toast({
        position: "top",
        title: "Phone Number Copied.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });

      // setFollowupLogData({
      //   email: "",
      //   original_status: "",
      //   current_status: "",
      //   status: "",
      // });
    } catch (error) {
      console.error("Error in follow-up flow:", error);
    }
  };

  return (
    <div>
      <Flex h="250px" justifyContent="center">
        <Box
          w="30%"
          bg="#dbeeed"
          my={10}
          mx={6}
          px={4}
          py={8}
          borderRadius="md"
        >
          <Box bg="white" px={2} py={2} mb={2}>
            <Flex align="center" gap={4}>
              <FaUser />
              <Text fontSize="medium">{name}</Text>
            </Flex>
          </Box>
          <Box bg="white" px={2} py={2} mb={2}>
            <Flex justify="space-between" align="center">
              <Flex align="center" gap={4}>
                <FaPhoneAlt />
                <Text fontSize="medium">{phoneNumber}</Text>
              </Flex>
              <Flex align="center" gap={4}>
                <Button size="sm" onClick={copyToClipboard}>
                  <MdContentCopy />
                </Button>
                <Button
                  size="sm"
                  disabled={isWhatsappUnavailable}
                  onClick={async () => {
                    const formatted = `+91${phoneNumber.slice(-10)}`;
                    try {
                      await FollowupLogNotificationService.createFollowupLog({
                        email,
                        assigned_expert: loggedInUser,
                        channel: "whatsapp chat",
                        template: "",
                        original_status,
                        current_status,
                      });
                      // setFollowupLogData({
                      //   email: "",
                      //   original_status: "",
                      //   current_status: "",
                      //   status: "",
                      // });

                      window.open(`https://wa.me/${formatted}`);
                    } catch (error) {
                      console.error(error);
                    }
                  }}
                >
                  <MdWhatsapp />
                </Button>
              </Flex>
            </Flex>
          </Box>
        </Box>
      </Flex>
    </div>
  );
};
